import { API } from "config/api";
import { API_ROUTES } from "config/apiRoutes";

export type MissingCognitoUser = {
  user_id: string;
  email: string;
  name: string;
  role: string;
};

export async function fetchUsersMissingFromCognito(): Promise<{
  users: MissingCognitoUser[];
  count: number;
}> {
  const { data } = await API.get(API_ROUTES.USERS.MISSING_COGNITO());
  return data;
}
